import { ROUTES_WITH_ELEMENTS } from '@/utils/routes/routesWithElements'
import { AUTH_LOGIN_PATH } from '@/utils/routes/authLoginPath'

// e.g. PATHS['auth'], PATHS['auth.reset-otp']
export const PATHS: PathMapType = {
  ...Object.entries(ROUTES_WITH_ELEMENTS).reduce((parentAcc, parent) => {
    const parentKey = parent[0] as keyof typeof ROUTES_WITH_ELEMENTS
    const childMap = parent[1]

    // 실제 Path는 kebabCase 로 처리 (resetOtp -> reset-otp)
    return {
      ...parentAcc,
      [parentKey]: `/${parentKey}`,
      ...Object.entries(childMap).reduce(
        (childAcc, [childPath]) => ({
          ...childAcc,
          [`${parentKey}.${childPath}`]: `/${parentKey}/${childPath}`,
        }),
        {} as PathMapType,
      ),
    }
  }, {} as PathMapType),
  // LOGISPRD-12506: 위 generic reduce도 'auth'+'login' 키로 동일한 '/auth/login'을 만들어내지만,
  // authLoginPath.ts(AuthUtils가 쓰는 단일 출처)와 값이 절대 갈라지지 않도록 마지막에 명시적으로
  // 덮어써 둔다. 값은 원래도 같았으므로 다른 PATHS 키의 동작은 바뀌지 않는다.
  'auth.login': AUTH_LOGIN_PATH,
}

type PathKeys = NestedKeysWithParent<typeof ROUTES_WITH_ELEMENTS>
type PathMapType = Record<PathKeys, string>
